import { CALL_API } from '../middleware/api';

export const FETCHING_ACTIVITIES = Symbol('FETCHING_ACTIVITIES');
export const FETCHING_ACTIVITIES_SUCCESS = Symbol('FETCHING_ACTIVITIES_SUCCESS');
export const FETCHING_ACTIVITIES_FAILURE = Symbol('FETCHING_ACTIVITIES_FAILURE');
export const FETCHING_ACTIVITIES_ONLY_VALUES = Symbol('FETCHING_ACTIVITIES_ONLY_VALUES');
export const FETCHING_ACTIVITIES_ONLY_VALUES_SUCCESS = Symbol('FETCHING_ACTIVITIES_ONLY_VALUES_SUCCESS');
export const FETCHING_ACTIVITIES_ONLY_VALUES_FAILURE = Symbol('FETCHING_ACTIVITIES_ONLY_VALUES_FAILURE');

/**
 * Fetch event activities.
 */
export function fetchEventActivities() {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/browse/activities?only_values=0`,
      startType: FETCHING_ACTIVITIES,
      errorType: FETCHING_ACTIVITIES_FAILURE,
      successType: FETCHING_ACTIVITIES_SUCCESS,
    },
  };
}

/**
 * Fetch event activities, only values.
 */
export function fetchEventActivitiesOnlyValues() {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/browse/activities?only_values=1`,
      startType: FETCHING_ACTIVITIES_ONLY_VALUES,
      errorType: FETCHING_ACTIVITIES_ONLY_VALUES_FAILURE,
      successType: FETCHING_ACTIVITIES_ONLY_VALUES_SUCCESS,
    },
  };
}
